import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Button } from 'reactstrap';
import {
  Field, reduxForm, startSubmit,
} from 'redux-form';
import ParentFields from './ParentFields';

class View extends Component {
  constructor(props) {
    super(props);
    this.form = React.createRef();
  }

  render() {
    const {
      submitting, invalid, hiddenFields, setSubmittingState,
      action, backAction, backMethod, name,
    } = this.props;
    return (
      <form action={action} method="post" ref={this.form} onSubmit={() => setSubmittingState('ParentForm')}>
        <div dangerouslySetInnerHTML={{ __html: hiddenFields }} />
        <Field name="authenticity_token" type="hidden" component="input" />
        <ParentFields formName="ParentForm" name={name} />
        <Button
          className="submit"
          type="submit"
          disabled={invalid || submitting}
          color="danger"
          size="lg"
        >
          次へ
        </Button>
        <Button
          className="back"
          color="secondary"
          size="lg"
          disabled={submitting}
          onClick={(e) => {
            e.preventDefault();
            this.form.current.method = backMethod;
            this.form.current.action = backAction;
            this.form.current.submit();
          }}
        >
          もどる
        </Button>
      </form>
    );
  }
}

View.defaultProps = {
  backMethod: 'post',
};

View.propTypes = {
  submitting: PropTypes.bool.isRequired,
  invalid: PropTypes.bool.isRequired,
  hiddenFields: PropTypes.string.isRequired,
  setSubmittingState: PropTypes.func.isRequired,
  action: PropTypes.string.isRequired,
  backAction: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  backMethod: PropTypes.string,
};

export default reduxForm({
  form: 'ParentForm',
  validate: () => {
    const errors = {};
    return errors;
  },
})(connect(null, (dispatch) => ({
  setSubmittingState: (formId) => {
    dispatch(startSubmit(formId));
  },
}))(View));
